import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Dashboard } from '../../pages/Dashboard'

const dashboardSearchSchema = z.object({
  organizationIds: z.array(z.string()).optional().catch([]),
})

export const Route = createFileRoute('/helpdesk/dashboard')({
  component: Dashboard,
  validateSearch: dashboardSearchSchema,
})